import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { logger } from "@/utils/logger"; // Importa para inicializar
import AnalyticsTracker from "@/components/AnalyticsTracker";
import Index from "@/pages/Index";
import Login from "@/pages/Login";
import Success from "@/pages/Success";
import AuthCallback from "@/pages/AuthCallback";
import SharedLetter from "@/pages/SharedLetter";
import AdminLayout from "@/layouts/AdminLayout";
import Admin from "@/pages/Admin";
import ScheduledLetters from "@/pages/admin/ScheduledLetters";
import AvailableLetters from "@/pages/admin/AvailableLetters";
import ViewLetter from "@/pages/admin/ViewLetter";
import Account from "@/pages/admin/Account";
import UsersManagement from "@/pages/admin/UsersManagement";
import Settings from "@/pages/admin/Settings";
import WriteNewLetter from "@/pages/admin/WriteNewLetter";
import EditLetter from "@/pages/admin/EditLetter";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AnalyticsTracker />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/entrar" element={<Login />} />
            <Route path="/sucesso" element={<Success />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/carta/:id" element={<SharedLetter />} />
            
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Admin />} />
              <Route path="cartas-agendadas" element={<ScheduledLetters />} />
              <Route path="cartas-disponiveis" element={<AvailableLetters />} />
              <Route path="carta/:id" element={<ViewLetter />} />
              <Route path="editar-carta/:id" element={<EditLetter />} />
              <Route path="conta" element={<Account />} />
              <Route path="usuarios" element={<UsersManagement />} />
              <Route path="configuracoes" element={<Settings />} />
              <Route path="escrever-carta" element={<WriteNewLetter />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster />
      </QueryClientProvider>
    </React.StrictMode>
  );
}

export default App;